// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1heFr","label":"styles_label__EtM7M"};